angular.module('impactx.selectionDialog', []);